// Entry point for the build script in your package.json.
import "@hotwired/turbo-rails"

// Stimulus controllers.
import "./controllers"

import * as bootstrap from "bootstrap"
